import React from "react";
import {
    Popover,
    Typography,
    Badge,
    Grid,
    IconButton,
    List,
    styled,
} from "@mui/material";
import Notifications from '@mui/icons-material/Notifications';
import NotificationsOff from '@mui/icons-material/NotificationsOff';
import GenericNotification from "../NotificationTypes/GenericNotification";

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        top: 13,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: "0 4px",
    },
}));

export default function NotificationsPopover({
    notificationsArray = [],
    setNotifications = () => {},
}) {
    const notifs = Array.isArray(notificationsArray) ? notificationsArray : [];

    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleNotificationUpdate = (updatedNotif) => {
        if (typeof setNotifications !== "function") return;
        setNotifications(
            notifs.map((n) => (n?.uuid === updatedNotif?.uuid ? { ...n, seen: true } : n))
        );
    };
    const handleNotificationDelete = (deletedUuid) => {
        if (typeof setNotifications !== "function") return;
        setNotifications(notifs.filter((n) => n?.uuid !== deletedUuid));
    };

    const open = Boolean(anchorEl);
    const id = open ? "notifications-popover" : undefined;

    const unreadCount = React.useMemo(
        () => notifs.filter((n) => !n?.seen).length,
        [notifs]
    );

    return (
        <div>
            <IconButton
                aria-describedby={id}
                sx={{ padding: "10px !important", color: "#FFF", cursor: "pointer" }}
                aria-label="notifications"
                onClick={handleClick}
            >
                {unreadCount > 0 ? (
                    <StyledBadge badgeContent={unreadCount} color="error">
                        <Notifications style={{ color: "black" }} />
                    </StyledBadge>
                ) : (
                    <Notifications style={{ color: "black" }} />
                )}
            </IconButton>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <div style={{ width: "100%", maxWidth: 360 }}>
                    {notifs.length === 0 ? (
                        <Typography sx={{ padding: 2 }}>
                            <Grid container spacing={2}>
                                <Grid item><NotificationsOff /></Grid>
                                <Grid item>Aucune notification disponible</Grid>
                            </Grid>
                        </Typography>
                    ) : (
                        <>
                            <Typography sx={{ pt: 2, pr: 2, pl: 2 }}>
                                <Grid container spacing={2}>
                                    <Grid item><Notifications /></Grid>
                                    <Grid item>Notifications</Grid>
                                </Grid>
                            </Typography>
                            <List sx={{ overflowY: "auto", maxHeight: "300px" }}>
                                {notifs.map((notif) => (
                                    <GenericNotification
                                        key={notif?.uuid ?? Math.random()}
                                        notif={notif}
                                        onUpdate={handleNotificationUpdate}
                                        onDelete={handleNotificationDelete}
                                    />
                                ))}
                            </List>
                        </>
                    )}
                </div>
            </Popover>
        </div>
    );
}
